import request from '..';

const SERVER_PUBLIC = `${process.env.REACT_APP_SERVER_ENVIRONMENT}/api/v1/pss-bff-public`;
const SERVER_PROTECTED = `${process.env.REACT_APP_SERVER_ENVIRONMENT}/api/v1/pss-bff-protected`;

// Obtiene el detalle del vehiculo por patente
export const getDocumentsByShortId = async (shortId: string) => {
  return await request({
    url: `${SERVER_PUBLIC}/tracking/${shortId}`,
    method: 'GET',
  });
};

export const uploadDocumentByDocId = async (data: any, id: any) => {
  console.log(data, id, 'aaaaaaaaaaaaaaaaaaaaaaaaa')
  const formData = new FormData();
  formData.append('files', data);


  console.log(formData, 'formdata')

  return await request({
    url: `${SERVER_PROTECTED}/claims/documents-client/${id}`,
    method: 'POST',
    data: formData,
  });
};

export const getUrlFileBase64FromPSS = async (filename: string) => {
  return await request({
    url: `${SERVER_PUBLIC}/documents/pss/view?filename=${filename}`,
    method: 'GET',
    // Headers: {
    //   "Content-disposition": "inline; filename=filename",
    // }
  });
};

export const updateDocEntity = async (id: any, data: any) => {
  return await request({
    url: `${SERVER_PROTECTED}/claims/documents/public/${id}`,
    method: 'PUT',
    data: data,
  });
};


